import React from "react";
import "./scss/manager-product-card.scss";
import ApiImage from "./ApiImage";
import { useNavigate } from "react-router-dom";

export default function ManagerProductCard({ product }) {
  const navigate = useNavigate();

  return (
    <div className="manager-product-card" onClick={() => { navigate(`/manager/product/${product.id}`) }}>

      <div className="manager-product-card__image">
        <ApiImage src={product.photo} alt={product.title} />

        {product.status === "check" && (
          <div className="manager-product-card__badge check">
            На проверке
          </div>
        )}

        {product.status === "approved" && (
          <div className="manager-product-card__badge approved">
            Опубликован
          </div>
        )}
      </div>

      <div className="manager-product-card__price">
        {product.price}
      </div>

      <div className="manager-product-card__title">
        {product.title}
      </div>

      <div className="manager-product-card__rating">
        ⭐ {product.rating} · {product.reviews} оценок
      </div>

    </div>
  );
}
